import { render, staticRenderFns } from "./BulkInventoryItemLocationList.vue?vue&type=template&id=5074957a&scoped=true"
import script from "./BulkInventoryItemLocationList.vue?vue&type=script&lang=ts"
export * from "./BulkInventoryItemLocationList.vue?vue&type=script&lang=ts"
import style0 from "./BulkInventoryItemLocationList.vue?vue&type=style&index=0&id=5074957a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074957a",
  null
  
)

export default component.exports